import React from "react"
import { SortingItem } from "../../../utils/api-objects/SortingItem"
import { getFormattedDateWithInput } from "../../../utils/Functions"

interface Props {
    items: SortingItem[],
    patientEmail: string,
}

const SortingItemTable: React.FC<Props> = ({ items, patientEmail }) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-[900px] w-full border border-black text-xs">
                <thead className="bg-gray-100 text-left">
                    <tr>
                        <th className="px-4 py-2 border">Acquirente</th>
                        <th className="px-4 py-2 border">Prodotto</th>
                        <th className="px-4 py-2 border">Redeemability</th>
                        <th className="px-4 py-2 border">Già associato?</th>
                        <th className="px-4 py-2 border">Associato a</th>
                        <th className="px-4 py-2 border">Data acquisto</th>
                        <th className="px-4 py-2 border">Ultimo aggiornamento</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.created_at + item.buyer} className={`border-t ${item.redeemability === true && "text-holifya-grey"} ${item.redeemed_by === patientEmail ? "text-holifya-blue" : "text-holifya-red"}`}>
                            <td className="px-4 py-2 border">{item.buyer}</td>
                            <td className="px-4 py-2 border">{item.product_type}</td>
                            <td className="px-4 py-2 border">{item.redeemability ? "Yes" : "No"}</td>
                            <td className="px-4 py-2 border">{item.redeemable_by ?? "--"}</td>
                            <td className={`px-4 py-2 border`}>{item.redeemed_by ?? "--"}</td>
                            <td className="px-4 py-2 border">{getFormattedDateWithInput(item.created_at)}</td>
                            <td className="px-4 py-2 border">{getFormattedDateWithInput(item.updated_at)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SortingItemTable